import { Bonus, createUnblockBonusMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type UnblockBonusModel = ConfirmModalModel<Bonus, number, Bonus>;

export const createUnblockBonusModel = (): UnblockBonusModel => {
	const unblockBonusMutation = createUnblockBonusMutation();

	const model = createConfirmModalModel<Bonus, number, Bonus>({
		modalData: declareModalData<Bonus>(),
		mapModalData: ({ id }) => id,
		mutation: unblockBonusMutation,
		successMessageKey: 'unblock-bonus.success',
	});

	return model;
};
